export {
  Slot,
  Slottable,
  //
  Root,
} from './Slot';
export type { SlotProps } from './Slot';
